import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  min-height: 692px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  overflow: hidden;
  background: linear-gradient(
    108deg,
    rgba(204, 143, 45, 1) 0%,
    rgb(0 0 0) 100%
  );


  @media screen and (max-width: 768px) {
    min-height: 100vh;
    position: relative; /* Change from fixed to relative on mobile */
    height: auto;
  }
`;

export const FormWrap = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 400px) {
    height: 80%;
  }
`;

export const Icon = styled(Link)`
  margin-left: 32px;
  margin-top: 32px;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  font-size: 32px;

  @media screen and (max-width: 480px) {
    margin-left: 16px;
    margin-top: 8px;
  }
`;

export const FormContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 480px) {
    padding: 10px;
    margin-top:200px;
  }
`;

export const Form = styled.form`
  background: #010101;
  max-width: 400px;
  height: auto;
  width: 100%;
  z-index: 1;
  display: grid;
  margin: 0 auto;
  padding: 80px 32px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);

  @media screen and (max-width: 400px) {
    padding: 32px 32px;
  }
`;

export const FormOut = styled.form`
  background: #101522;
  height: auto;
  width: 100%;
  z-index: 1;
  display: grid;
  margin: 0 auto;
  padding: 80px 32px;
  justify-content: center;
  align-items: center;
`;

export const FormH1 = styled.h1`
  margin-bottom: 40px;
  color: #fff;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
`;

export const FormLabel = styled.label`
  margin-bottom: 8px;
  font-size: 14px;
  color: #fff;
`;
export const FormInput = styled.input`
  padding: 16px 16px;
  margin-bottom: 32px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
`;

export const FormButton = styled.button`
  background: ${({ checked }) => (checked ? '#cc8f2d' : 'gray')};
  padding: 16px 0;
  border: none;
  border-radius: 4px;
  color: black;
  font-size: 20px;
  cursor: pointer;
`;

export const Text = styled.span`
  text-align: center;
  margin-top: 24px;
  color: #fff;
  font-size: 14px;
  padding-bottom: 20px;
`;

export const NavBtnLink = styled(Link)`
  border-radius: 50px;
  background: #cc8f2d;
  white-space: nowrap;
  padding: 10px 22px;
  color: black;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
  }
`;

export const SignUpTermsContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  padding-bottom: 20px;
`;

export const StyledCheckbox = styled.input.attrs({ type: 'checkbox' })`
  // width: 20px;
  // height: 20px;
  border: 2px solid #cc8f2d;
  margin-left: 8px;
  margin-right: 12px;
  position: relative;
  accent-color: #cc8f2d;
  transition: background-color 0.3s ease;
  // background-color: ${({ checked }) => (checked ? 'white' : 'cc8f2d')};
`;

export const CheckboxText = styled.span`
  text-align: center;
  color: #fff;
  font-size: 14px;
`;
